import { useState } from "react";
import SurveyIngestion from "@solimat/solimat-web-endpoint/lib/survey-ingestion";

const useCreateUserSurvey = () => {
  const BASE_URL = import.meta.env.VITE_REACT_APP_ENCUESTAS_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_ENCUESTAS_KEY || "";
  const apiSurvey = new SurveyIngestion.SurveyIngestionService(BASE_URL, FUNCTIONS_KEY);

  const [loadingCreateUserSurvey, setLoadingCreateUserSurvey] = useState(false);
  const [successCreateUserSurvey, setSuccessCreateUserSurvey] = useState(false);
  const [errorCreateUserSurvey, setErrorCreateUserSurvey] = useState(null);
  
  const createUserSurvey = (data:any, _cb?:()=>void) => {
    setLoadingCreateUserSurvey(true);
    setErrorCreateUserSurvey(null);
    apiSurvey
      .createUserSurvey(data)
      .then((res: any) => {
        setSuccessCreateUserSurvey(true);
        setLoadingCreateUserSurvey(false);
        if (typeof _cb === "function") {
          _cb();
        }
      })
      .catch((err:any) => {
        console.error("createUserSurvey error: ", err);
        setErrorCreateUserSurvey(err);
        setLoadingCreateUserSurvey(false);
        if (typeof _cb === "function") {
          _cb();
        }
      });
  };

  return {
    createUserSurvey,
    successCreateUserSurvey,
    loadingCreateUserSurvey,
    errorCreateUserSurvey
  };
};

export default useCreateUserSurvey;